
import { mapState, mapGetters } from 'vuex'
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: true,
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
        }),
        ...mapGetters({
            depositInstruction: 'cms/depositInstruction',
            companyBankAccounts: 'themes/company-bank/companyBankAccount',
        }),
    },
    async mounted() {
        const params = { currency: this.$cookie.get('player')?.currency }
        try {
            await this.$store.dispatch(
                'themes/company-bank/getCompanyBankPlayerAccount',
                params
            )
        } finally {
            this.isLoading = false
        }
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    methods: {
        getBankDetails(item) {
            return [
                { label: this.tl('bankName'), value: item?.bank_name },
                {
                    label: this.tl('bankAccountNumber'),
                    value: item?.bank_account_number,
                },
                {
                    label: this.tl('bankAccountHolderName'),
                    value: item?.bank_account_name,
                },
                { label: this.tl('bankBranch'), value: item?.bank_branch },
                { label: this.tl('bankAddress'), value: item?.address },
            ]
        },
    },
}
